import { DoubleSide, RepeatWrapping } from "three";
import { memo, useMemo, useRef } from "react";
import { Box, Environment, useEnvironment } from "@react-three/drei";
import { jsx } from "react/jsx-runtime";
import { useFrame } from "@react-three/fiber";
var speed = .005;
const RotatingEnvironment = memo(({ url }) => {
	const texture = useEnvironment({ files: url });
	const ref = useRef(null);
	useMemo(() => {
		texture.wrapS = RepeatWrapping;
	}, [texture]);
	useFrame((_, dt) => {
		if (!ref.current) return;
		texture.offset.x = texture.offset.x + speed * dt;
		texture.offset.x %= 1;
	});
	return /* @__PURE__ */ jsx(Environment, {
		near: 1,
		far: 1e3,
		frames: Infinity,
		resolution: 256,
		blur: .5,
		children: /* @__PURE__ */ jsx(Box, {
			ref,
			scale: 300,
			position: [
				0,
				-50,
				0
			],
			children: /* @__PURE__ */ jsx("meshBasicMaterial", {
				map: texture,
				side: DoubleSide
			})
		})
	});
});
RotatingEnvironment.displayName = "RotatingEnvironment";
export { RotatingEnvironment };

//# sourceMappingURL=index241.js.map